import { roles } from 'commons/auth/roles';

export default class ClearValues {
    /**
     * CLEAR VALUE display controller
     * @param profileRoles
     * @param elementType
     * @param value
     * @param elementStatus
     * @param surveyStatus
     */
    public static displayController(
        profileRoles: any,
        elementType: string,
        value: any,
        elementStatus: number,
        surveyStatus: number
    ) {
        // elements
        switch (elementType) {
            case 'button':
            case 'close_observation_period':
            case 'collection':
            case 'table': {
                return false;
            }
        }

        // roles
        if (profileRoles.some((role: string) => roles.dataManager.includes(role) || roles.monitor.includes(role))) {
            return false;
        }

        /** block if value is not initial, or status survey is 4 */
        // if (!value || value?.data[0] === '' || value?.data === [] || surveyStatus === 4) {
        if (!value || value?.data[0] === '' || value?.data?.length === 0 || surveyStatus === 4) {
            return false;
        }

        // element status
        switch (elementStatus) {
            case 1:
            case 3: {
                return false;
            }
        }

        return true;
    }
}
